/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramChatsUserControllerUpsertMutationRequest,
  TelegramChatsUserControllerUpsertMutationResponse,
  TelegramChatsUserControllerUpsert401,
  TelegramChatsUserControllerUpsert404,
} from '../../types/TelegramChatsUserControllerUpsert.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramChatsUserUpsert } from '../../methods/telegramChatsUserUpsert.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramChatsUserUpsertMutationKey = () => [{ url: '/api/user/telegram/chats' }] as const;

export type TelegramChatsUserUpsertMutationKey = ReturnType<typeof telegramChatsUserUpsertMutationKey>;

/**
 * {@link /api/user/telegram/chats}
 */
export function useTelegramChatsUserUpsert<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramChatsUserControllerUpsertMutationResponse,
      ResponseErrorConfig<TelegramChatsUserControllerUpsert401 | TelegramChatsUserControllerUpsert404>,
      { data: TelegramChatsUserControllerUpsertMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramChatsUserControllerUpsertMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramChatsUserUpsertMutationKey();

  return useMutation<
    TelegramChatsUserControllerUpsertMutationResponse,
    ResponseErrorConfig<TelegramChatsUserControllerUpsert401 | TelegramChatsUserControllerUpsert404>,
    { data: TelegramChatsUserControllerUpsertMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramChatsUserUpsert(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
